/* eslint-disable react-hooks/exhaustive-deps */
import BackupTableIcon from '@mui/icons-material/BackupTable';
import { useEffect, useState } from 'react';
import { ReactComponent as ChromeICon } from "../../../assets/svgs/chrome.svg";
import { ReactComponent as AlbanianFlag } from "../../../assets/svgs/flags/albania.svg";
import { ReactComponent as GreeceFlag } from "../../../assets/svgs/flags/grece.svg";
import { ReactComponent as MacedoniaFlag } from "../../../assets/svgs/flags/makedonia.svg";
import { formatBbPrice } from '../../../utils/common';


const status = (data = '', orderTransformer) => {
	return (
		<div className='flex gap-4 items-center justify-start'>
			<div style={{
				width: "8px",
				height: "8px",
				backgroundColor: `${orderTransformer[data]?.bgColor}`, borderRadius: '50%'
			}} className='flex justify-center items-center gap-3'>
			</div>
			<span
				className="text-[12px]"
			>
				{orderTransformer[data]?.readable}
			</span>
		</div>
	)
}

function getRandomBoolean() {
	return Math.random() < 0.5;
}

export function getRandomIP() {
	const ipParts = [];
	for (let i = 0; i < 4; i++) {
		ipParts.push(Math.floor(Math.random() * 256));
	}
	const randomIP = ipParts.join('.');

	const randomFlag = Math.floor(Math.random() * 3); // 0 for Albania, 1 for Macedonia, 2 for Greece
	let flagComponent;

	switch (randomFlag) {
		case 0:
			flagComponent = <AlbanianFlag />;
			break;
		case 1:
			flagComponent = <MacedoniaFlag />;
			break;
		case 2:
			flagComponent = <GreeceFlag />;
			break;
		default:
			flagComponent = null;
	}

	return (
		<div className='flex gap-3 items-center h-[40px]'>
			<div style={{ width: "34px", height: "25px" }}>{flagComponent}</div>
			{randomIP}
		</div>
	);
};



export const GetStateFromIp = ({ data: ip }) => {
	const [state, setState] = useState()
	const handleCheck = async () => {
		try {
			const response = await fetch(`https://api.country.is/${ip}`);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const data = await response.json();

			if (data.country) { // Use data.country
				let flagComponent;
				switch (data.country) {  // Use data.country
					case "AL":
						flagComponent = <AlbanianFlag />;
						break;
					case "MK":
						flagComponent = <MacedoniaFlag />;
						break;
					case "GR":
						flagComponent = <GreeceFlag />;
						break;
					default:
						flagComponent = null;
				}
				setState(flagComponent);
			} else {
				setState(null);
			}
		} catch (error) {
			return null;
		}


	}

	useEffect(() => {
		handleCheck()
	}, [])




	return (
		<div className='flex gap-3 items-center h-[40px]'>
			<div style={{ width: "34px", height: "25px" }}>{state}</div>
			{ip}
		</div>
	);
}

export const columnsRenderTable = (orderTransformer, render = true, isBBShop = false) => [
	{
		field: 'order_number', label: 'Order', align: 'center',
		cellComponent: ({ data }) => (
			<div className="whitespace-nowrap w-full text-left">
				{data}
			</div>
		),
	},
	{
		field: 'customer_full_name', label: isBBShop ? "Client" : 'Customer', align: 'center',
		cellComponent: ({ data }) => (
			<div className="whitespace-nowrap w-full text-left">
				{data}
			</div>
		),

	},
	{
		field: 'ip', label: 'IP', align: 'center',
		cellComponent: (props) => <GetStateFromIp {...props} />
	},
	{
		field: 'created_at',
		label: 'Date',
		align: 'center',
		cellComponent: ({ data }) => (
			<div className="whitespace-nowrap w-full text-left">
				{data}
			</div>
		),

	},
	...(render
		? [
			{
				field: 'payment_method_id',  // Use payment_method_id directly instead of payment_method
				label: isBBShop ? "Payment" : 'Pay with',
				align: 'end',
				cellComponent: ({ data }) => (
					<div>
						{data === 1 ? 'Cash' : 'BKT'}
					</div>
				)
			}

		]
		: []),
	...(!isBBShop ? [{ field: 'order_for', label: 'Order for', align: 'center' }] : []),
	{
		field: 'status',
		label: 'Status',
		align: 'center',
		cellComponent: ({ data }) => status(data, orderTransformer),
	},
	{
		field: 'total_amount',
		label: 'Total',
		align: 'center',
		cellComponent: ({ data, row }) => <span className='text-nowrap'>{`${isBBShop ? formatBbPrice(data) : `${row?.currency ?? ''} ${data}`}`}</span>,
	},
	...(isBBShop
		? [
			{
				field: 'source_id',
				label: 'Agent',
				align: 'start',
				cellComponent: ({ data }) => {
					console.log('source_id value:', data);

					// Define display content based on source_id
					let displayContent;
					let colors;

					if (data === 1) {
						// Web Checkout
						colors = { bgColor: "#E8CCEB", textColor: "#5E35B7" };
						displayContent = (
							<>
								<ChromeICon /> Web Checkout
							</>
						);
					} else if (data === 3) {
						// Web Modal - specifically for source_id 3
						colors = { bgColor: "#F0E6FA", textColor: "#433897" };
						displayContent = (
							<>
								<BackupTableIcon /> Web Modal
							</>
						);
					} else {
						// Default or fallback for null/undefined/other values
						colors = { bgColor: "#F0E6FA", textColor: "#433897" };
						displayContent = (
							<>
								<ChromeICon /> Web Checkout
							</>
						);
					}

					return (
						<div className='p-1'>
							<div
								style={{ backgroundColor: colors.bgColor, color: colors.textColor }}
								className="flex items-center p-2 lg:p-3 rounded-lg gap-3 font-bold whitespace-nowrap">
								{displayContent}
							</div>
						</div>
					);
				}
			}
		]
		: []),
	{
		field: 'actions',
		label: 'Actions',
		align: 'end',
	},
]

export const transformedDataRenderTable = (displayedData = []) => displayedData;


